import styled from 'styled-components'

import { gap, GapProps, space, SpaceProps } from '../../themes'

export interface BaseFormProps
  extends SpaceProps,
    GapProps,
    React.HTMLAttributes<HTMLFormElement> {}

export const BaseForm = styled.form<BaseFormProps>`
  ${space}
  ${gap}
  width: 100%;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
`
